import axios from "axios";

axios.interceptors.request.use(
  function (config) {
    const TZ = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (TZ) {
      config.headers = config.headers || {};
      config.headers.TZ = TZ;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);
